// extracted by mini-css-extract-plugin
export var details = "_ki-0";
export var inspectorPopover = "_ki-1";